import {StatsTable} from "./StatsTable";
import * as React from "react";
import {
    LpExtendedStatsFragmentFragment,
    LpStatsFragmentFragment,
    LpStatsQueryResult, McStatsFragmentFragment,
    McStatsQueryResult, MeStatsFragmentFragment,
    MeStatsQueryResult, PeriodItemInput,
    useLpStatsQuery, useMcStatsQuery, useMeStatsQuery
} from "../../../types.d";
import moment from "moment";
import {StatsPeriod} from "./StatsPeriod";
import {useState} from "react";
import {CourseFilter} from "../../partials/CourseFilter";

export const lpExtendedStatsColumns = [
    [<b>Total<br />QS</b>, 'col-3', 'Total QS'],
    [<b>Vocabulary<br />QS</b>, 'col-3', 'Vocabulary QS'],
    [<b>Exercise<br />QS</b>, 'col-3', 'Exercise QS'],
    [<b>Review<br />QS</b>, 'col-2', 'Review QS'],
    [<b>Cards/day</b>, 'col-2', 'Cards/day'],
];

export const lpStatsColumns = [
    [<b>Vocabulary Cards<br />Created</b>, 'col-3', 'Created Cards'],
    [<b>Exercise Cards<br />Created</b>, 'col-3', 'Created Ex. Cards'],
    [<b>Cards<br />Reviewed</b>, 'col-2', 'Reviewed Cards'],
    [<b>Cards<br />Finished</b>, 'col-2', 'Finished Cards'],
];

export const lpExtendedStatsValues = (row: LpExtendedStatsFragmentFragment) => [
    row.totalQs,
    row.vocabularyQs,
    row.exerciseQs,
    row.reviewQs,
    row.cardsPerDay,
];

export const lpStatsValues = (row: LpStatsFragmentFragment) => [
    row.vocabularyCreated,
    row.exerciseCreated,
    row.totalReviewed,
    row.totalEscalated,
];

export const meStatsColumns = [
    [<b>Media Added</b>, 'col-3', 'Created Info'],
    [<b>Media Good</b>, 'col-3', 'Good Info'],
    [<b>Media Reviewed</b>, 'col-2', 'Reviewed'],
    [<b>Media Finished</b>, 'col-2', 'Finished'],
];

export const meStatsValues = (row: MeStatsFragmentFragment) => [
    row.mediaCreated,
    row.mediaGood + ` (${row.mediaGoodPercent})`,
    row.mediaReviewed,
    row.mediaEscalated,
];

export const mcStatsColumns = [
    [<b>Mnemo Created</b>, 'col-3', 'Created Mnemo'],
    [<b>Mnemo<br />Reviewed</b>, 'col-3', 'Reviewed'],
    [<b>Mnemo Finished</b>, 'col-3', 'Finished'],
];

export const mcStatsValues = (row: McStatsFragmentFragment) => [
    row.mnemoCreated,
    row.mnemoReviewed,
    row.mnemoEscalated,
];

export const RoleStats = (props: {
    my: boolean,
    userId?: number,
    role: string,
    all?: boolean
}) => {
    const [all, setAll] = useState(false);

    const format = 'YYYY-MM-DD HH:mm:ss';
    let periods = [
        {
            name: 'This month',
            dateStart: moment().startOf('month').startOf('day').format(format) ,
            dateEnd: moment().endOf('day').format(format)
        },
        {
            name: 'Last month',
            dateStart: moment().subtract(1, 'month').startOf('month').startOf('day').format(format),
            dateEnd: moment().subtract(1, 'month').endOf('month').endOf('day').format(format)
        },
        {
            name: 'Total' ,
            dateStart: moment("2010-01-01").format(format),
            dateEnd: moment().endOf('day').format(format)
        },
    ] as PeriodItemInput[];

    if (all) {
        const dateStart = moment('2018-01-01 00:00:01');
        const dateEnd = moment().endOf('day');
        periods = [];

        while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
            periods.unshift({
                name: dateStart.format('MMMM YYYY'),
                dateStart: dateStart.startOf('month').format(format),
                dateEnd: dateStart.endOf('month').format(format),
            } as PeriodItemInput);

            dateStart.add(1, 'month');
        }
    }

    const options = {
        fetchPolicy: 'network-only' as any,
        variables: {
            my: props.my,
            userId: props.userId,
            periods,
            role: props.role
        }
    };

    let stats: LpStatsQueryResult | MeStatsQueryResult | McStatsQueryResult;
    let values: (row: any) => any[];

    let columns: any[] = [];

    switch (props.role) {
        case 'LP':
            stats = useLpStatsQuery(options);
            columns = lpStatsColumns;
            values = lpStatsValues;
            break;
        case 'ME':
            stats = useMeStatsQuery(options);
            columns = meStatsColumns;
            values = meStatsValues;
            break;
        case 'MC':
            stats = useMcStatsQuery(options);
            columns = mcStatsColumns;
            values = mcStatsValues;
            break;
    }

    if (!stats.data) {
        return null;
    }

    return <>
        <StatsTable columns={columns} />

        { (stats.data.stats as any[]).map(item => {
            return <StatsPeriod
                key={item.period}
                title={item.period}
                columns={columns}
                values={values(item.details)} />
        }) }

        <div className={'col-sm-12 text-center mt-5'}>
            <a href={''} onClick={e => {
                e.preventDefault();

                setAll(!all);
            }}>{ all ? 'See less months' : 'See all months' }</a>
        </div>
    </>
};
